const TipoProvaList = () => import("~/components/Views/Prova/TipoProva/List");
const TipoProvaNew = () => import("~/components/Views/Prova/TipoProva/New");

import auth from "~/middleware/auth";
import perfilVerify from "~/middleware/perfilVerify";

const breadcrumb = [
  { name: "Integrado", link: "http://on.grupointegrado.br/" },
  { name: "Prova", link: "" },
  { name: "Administração", link: "" }
];

export const tipoProva = [
  {
    path: "administracao/tipo-prova",
    component: TipoProvaList,
    name: "Tipo de Prova",
    meta: {
      title: "Tipo de Prova",
      middleware: [auth, perfilVerify],
      breadcrumb
    }
  },
  {
    path: "administracao/tipo-prova/new",
    component: TipoProvaNew,
    name: "Novo Tipo de Prova",
    meta: {
      title: "Novo Tipo de Prova",
      middleware: [auth, perfilVerify],
      breadcrumb
    }
  },
  {
    path: "administracao/tipo-prova/:id",
    component: TipoProvaNew,
    name: "Alterar Tipo de Prova",
    meta: {
      title: "Alterar Tipo de Prova",
      middleware: [auth, perfilVerify],
      breadcrumb
    }
  }
];



// WEBPACK FOOTER //
// ./src/routes/prova/administracao/tipoProva.js